import { useState } from 'react';

interface HeaderProps {
  isFixed: boolean;
}

export default function Header({ isFixed }: HeaderProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`w-full z-50 transition-all duration-300 ${
        isFixed ? 'fixed top-0 bg-white shadow-md' : 'absolute top-0 bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/57610a2a25a44577dbc5593c17f23216/f05b5e34bf1a8c792548fd7132f5d18d.png"
              alt="Pavitra Rishta Logo"
              className="h-24 w-auto object-contain"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-sm font-medium text-gray-700 hover:text-green-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-sm font-medium text-gray-700 hover:text-green-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className="text-sm font-medium text-gray-700 hover:text-green-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Products
            </button>
            <button
              onClick={() => scrollToSection('certifications')}
              className="text-sm font-medium text-gray-700 hover:text-green-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Certifications
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-sm font-medium text-gray-700 hover:text-green-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Contact
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-gray-700 cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200 py-4">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('home')}
                className="text-sm font-medium text-gray-700 hover:text-green-600 transition-colors text-left cursor-pointer"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="text-sm font-medium text-gray-700 hover:text-green-600 transition-colors text-left cursor-pointer"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('products')}
                className="text-sm font-medium text-gray-700 hover:text-green-600 transition-colors text-left cursor-pointer"
              >
                Products
              </button>
              <button
                onClick={() => scrollToSection('certifications')}
                className="text-sm font-medium text-gray-700 hover:text-green-600 transition-colors text-left cursor-pointer"
              >
                Certifications
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-sm font-medium text-gray-700 hover:text-green-600 transition-colors text-left cursor-pointer"
              >
                Contact
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
